export default "__VITE_ASSET__C8N0Mva2__"